const competitorImages = [
  `${process.env.PUBLIC_URL}/images/Freddy1.jpg`,
  `${process.env.PUBLIC_URL}/images/Freddy2.png`,
  `${process.env.PUBLIC_URL}/images/Freddy3.png`,
  `${process.env.PUBLIC_URL}/images/Freddy4.png`,
  `${process.env.PUBLIC_URL}/images/Freddy5.jpg`,
];

export default competitorImages;